import { httpClient } from "../../config/httpClient";
import { 
  API_GET_COUNTRIES, 
  API_GET_GENDERS, 
  API_GET_DOCUMENT_TYPES 
} from "../../common/consts/apiUrls";
import type { 
  CountriesResponse, 
  GendersResponse, 
  DocumentTypesResponse 
} from "../types/masterData";

/**
 * Servicio para obtener datos maestros del sistema
 * Estos datos se cargan una vez al inicio y se mantienen en el store global
 */

export const getCountries = async (): Promise<CountriesResponse> => {
  return httpClient.get<CountriesResponse>(API_GET_COUNTRIES);
};

export const getGenders = async (): Promise<GendersResponse> => {
  return httpClient.get<GendersResponse>(API_GET_GENDERS);
};

export const getDocumentTypes = async (): Promise<DocumentTypesResponse> => {
  return httpClient.get<DocumentTypesResponse>(API_GET_DOCUMENT_TYPES);
};

/**
 * Función helper para cargar todos los datos maestros en paralelo
 * Optimiza la carga inicial de la aplicación
 */
export const loadAllMasterData = async () => {
  try {
    const [countriesRes, gendersRes, documentTypesRes] = await Promise.all([
      getCountries(),
      getGenders(),
      getDocumentTypes(),
    ]);

    return {
      countries: countriesRes.data,
      genders: gendersRes.data,
      documentTypes: documentTypesRes.data,
    };
  } catch (error) {
    console.error("Error loading master data:", error);
    throw error;
  }
};
